import { render, staticRenderFns } from "./FXNoTransDetails.vue?vue&type=template&id=71f18938&scoped=true"
import script from "./FXNoTransDetails.vue?vue&type=script&lang=js"
export * from "./FXNoTransDetails.vue?vue&type=script&lang=js"
import style0 from "./FXNoTransDetails.vue?vue&type=style&index=0&id=71f18938&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f18938",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f18938')) {
      api.createRecord('71f18938', component.options)
    } else {
      api.reload('71f18938', component.options)
    }
    module.hot.accept("./FXNoTransDetails.vue?vue&type=template&id=71f18938&scoped=true", function () {
      api.rerender('71f18938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/FXNoTransDetails.vue"
export default component.exports